import {layouts} from './rawConfig/layouts'
import {groupAliases} from './rawConfig/groupAliases'
import {populateXySources} from './rawConfig/xySources'
import {populateWfsSources} from './rawConfig/wfsSources'
import {IConfig} from '../core/interfaces/reducers'

declare global {
  interface Window {
    [serverUrl: string]: string
  }
}

const xyApiUrl = process.env.HOST_API_URL
const geoserverApiUrl = process.env.GEOSERVER_URL
const rawConfig: IConfig = {
  others: {},
  layouts,
  groupAliases,
  urls: {
    publicRegisterUrl: xyApiUrl + '/Account/register',
    xyApiUrl: xyApiUrl,
    geoserverApiUrl: geoserverApiUrl,
    tokenServiceUrl: xyApiUrl + '/Account/token',
    selfInfoUrl: '',
    printServiceUrl: xyApiUrl + '/Export',
    printResultsUrl: xyApiUrl + '/Exports/Get',
    importResultsUrl: xyApiUrl + '',
    importServiceUrl: xyApiUrl + '/Import',
    bgtransService: xyApiUrl + '/BgTrans',
    streetImportCheckUrl: xyApiUrl + '/StreetImportCheck',
    importStreetRegUrl: xyApiUrl + '/ImportStreetReg/',
    importUnregulated: xyApiUrl + '/UnregulatedImport/',
    importCP: xyApiUrl + '/CPImport/'
  },
  locale: 'bg', //Can be hardcoded
  initState: {
    map: {
      popup: {
        show: false,
        coordinates: [0, 0],
        maximized: false,
        selectedPage: 0,
        loading: true
      },
      basemap: 'osm',
      center: [2851135.9380130954, 5256578.83269914],
      initExtent: [2470000, 5060000, 3212148, 5500000],
      zoom: 8,
      minZoom: 8,
      maxZoom: 24,
      sourcesImported: false,
      hardLoading: false
    }
  } as any,
  sourcesDescription: {}
}

if (xyApiUrl) populateXySources(rawConfig, xyApiUrl)
if (geoserverApiUrl) populateWfsSources(rawConfig, geoserverApiUrl)

export {rawConfig}
